import React from 'react';
import { useNavigate } from 'react-router-dom';
import ResponsiveTable from './ResponsiveTable';

function ByClientMonthAlbumsTable({
  data = [],
  totalCount,
  currentPage,
  pageSize,
  clientId,
}) {
  const navigate = useNavigate();
  const hasCsRate = data.some((row) => row.csRate != null);
  const columns = React.useMemo(
    () => [
      {
        Header: () => <div className="whitespace-nowrap text-center">순번</div>,
        id: 'index',
        accessor: (_row, i) => totalCount - ((currentPage - 1) * pageSize + i),
        Cell: ({ value }) => <div className="text-center">{value}</div>,
      },
      {
        Header: '커버',
        accessor: 'album.image',
        Cell: ({ row }) => (
          <img
            src={
              row.original.album.image ||
              'https://distribution-pink.s3.ap-northeast-3.amazonaws.com/dev/images/none_image.jpg'
            }
            alt={row.original.album.nameKr}
            className="w-12 h-12 rounded-full object-cover mx-auto border border-white/[0.08]"
          />
        ),
      },
      {
        Header: '앨범명',
        accessor: 'album.nameKr',
        Cell: ({ row }) => (
          <span
            className="font-bold text-sky-400 hover:cursor-pointer"
            onClick={() => {
              const { albumId, calculateMonth } = row.original;
              const resolvedClientId = row.original.album.albumClients?.clientId ?? clientId;
              navigate(
                `/ByClientMonthSongs?albumId=${albumId}&calculateMonth=${calculateMonth}&clientId=${resolvedClientId}`,
                { state: { clientId: resolvedClientId } }
              );
            }}>
            {row.original.album.nameKr}
          </span>
        ),
      },
      {
        Header: '아티스트',
        accessor: 'album.artist.nameKr',
      },
      {
        Header: '총 히트수',
        accessor: 'albumHitCount',
        Cell: ({ value }) => Number(value).toLocaleString(),
      },
      {
        Header: '총 정산액',
        accessor: 'clientAmount',
        Cell: ({ value }) => <b>{Number(value).toLocaleString()}</b>,
      },
      {
        Header: '수수료율',
        id: 'feeRate',
        Cell: ({ row }) => row.original.album?.feeRate != null ? `${row.original.album.feeRate}%` : '-',
      },
      ...(hasCsRate ? [{
        Header: '별도정산율',
        id: 'csRate',
        Cell: ({ row }) => row.original.csRate != null ? `${row.original.csRate}%` : '-',
      }] : []),
    ],
    [navigate, totalCount, currentPage, pageSize, hasCsRate]
  );

  return (
    <ResponsiveTable
      columns={columns}
      data={data}
      visibleOnMobile={['index', 'album.nameKr', 'clientAmount']}
    />
  );
}

export default ByClientMonthAlbumsTable;
